import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { Item } from '@app/core/components/listbox/listbox.component';

@Injectable({ providedIn: 'root' })
export class SrUserService {
    constructor(private datatask: DataTaskService) {}
    /** @datatask 1465 */
    public async getUser(portal_user_keyno: string): Promise<SrUserGet> { return (await this.datatask.Post(1465, { portal_user_keyno }))[0]; }
    /** @datatask 1470 */
    public async saveUser(page: SrUserGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1470, page))[0]; }
    /** @datatask 1466 */
    public getFontSizes(): Promise<SrFontSizeItem[]> { return this.datatask.Post(1466, {}); }
    /** @datatask 1469 */
    public getDeviationRights(): Promise<SrDeviationRightItem[]> { return this.datatask.Post(1469, {}); }
    /** @datatask 1633 */
    public getRefundLevels(): Promise<SrRefundLevelItem[]> { return this.datatask.Post(1633, {}); }
    /** @datatask 1463 */
    public async getUsersSettings(): Promise<SrUsersGet> { return (await this.datatask.Post(1463, {}))[0]; }
    /** @datatask 1464 */
    public getUsers(searchtext: string, show_deleted_users: string): Promise<Item[]> { return this.datatask.Post(1464, { searchtext, show_deleted_users }); }
}
export interface SrUserGet {
    portal_user_keyno: string | number;
    user_id_portal?: string;
    labour_name?: string;
    email?: string;
    mobilephone?: string;
    resource_id?: string;
    resource_searchtext?: string;
    language_id?: string;
    fontsize?: string | number;
    show_fontsize?: string;
    special_admin?: string;
    show_special_admin?: string;
    special_deviationright?: string;
    refund_access?: string;
    show_refund?: string;
    special_deleted?: string;
    show_savebutton?: string;
}
export interface SrUsersGet { searchtext: string; show_deleted_users: string; current_user_special_admin: string; }
export interface SrFontSizeItem { fontsize: string | number; fontsize_name: string; }
export interface SrDeviationRightItem { deviationright_no: string; deviationright_name: string; }
export interface SrRefundLevelItem { refundlevel_id: string; refundlevel_name: string; }
